import React from 'react';
import '../Styles/Resources.css';
import Header from '../../Components/JS/Headers.js'
import EmbeddedPDF from '../../Components/JS/EmbeddedPDF'
import CardCarousel from "../../Components/JS/CardCarousel"
import academicResources from '../../Data/CardCarousel';

const Resources = () => {
    return (
        <div className="resources">
            <div className="resource-container">
                <h1 className="resource-title">CS Resource Hub</h1>
                <p className="resource-description">A collection of computer science resources available for students at Western University.
                    If you would like to suggest an addition to this resource page, please contact csusuwo@gmail.com.</p>
                <div className="resource-links">
                    <a href="#academic-resources">Academic</a>
                    <a href="#recruiting-resources">Recruitment</a>
                    <a href="#event-resources">Events</a>
                    <a href="#constitution">Constitution</a>
                </div>
            </div>
            <div id="academic-resources" className="academic-resources">
                <Header name="academic-resources" subheading="ACE YOUR COURSES" heading="Academic resources"/>
                <CardCarousel academicResources={academicResources}/>
            </div>
            <div id="recruiting-resources">
                <Header name="recruiting-resources" subheading="LAND YOUR JOB" heading="Tech recruiting resources"/>
            </div>notlesl
            <div id="event-resources">
                <Header name="event-resources" subheading="UPCOMING EVENTS" heading="Events calendar"/>
            </div>
            <div id="constitution">
                <Header name="constitution" heading="Constitution"/>
                <EmbeddedPDF link="https://drive.google.com/file/d/1jHePIeX47FdwI_AeFtn7eNMJcFcR6oH3/preview"/>
            </div>
        </div>
    );
}
 
export default Resources;